export default "__VITE_ASSET__CftkWKad__"